module.exports = __webpack_public_path__ + "static/img/technology11.c69c88d4.png";